export default __webpack_public_path__ + "static/media/7.0f473abc.webp";